<template>
  <div
    id="topBar"
    class="d-flex "
    v-if="false"
  >
 

  
    <div v-if="isProject">
      <div
        class="navbar-container d-flex content align-items-center navbar-button"
        :class="(activeSec === 'downstream')? 'active' : ''"
        @click="goto('downstream')"
      >
        DOWNSTREAM ANALYSIS
      </div>
      
    </div>

    <div
        id="topLogout"
        class="navbar-container d-flex content align-items-center"
        style="cursor:pointer;max-width:200px"
        @click="isLoggedOut"
      >
        <feather-icon
          v-if="icon !== ''"
          icon="LogOutIcon"
          size="18"
          style="margin-right: 5px; color: #028380;"
        />
        <span style="color: #000; font-weight: 400;">LOGOUT </span>
    
  </div>
  </div>

</template>

<script>
import { mapGetters } from 'vuex'
import store from '@/store/index'

export default {
  components: {

  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      userName:'',
    }
  },
  computed: {
    ...mapGetters({
      title: 'title',
      icon: 'icon',
      isProject: 'isProject',
      isExperimental: 'isExperimental',
      activeSec: 'activeSec',
    }),
  },
  mounted() {
    if(this.$store.state.user.userdata != undefined){
        this.userName = this.$store.state.user.userdata.name + " " + this.$store.state.user.userdata.lastname
       
      }
    /* this.title = store.state.topBar.title
    console.log(` STORE -->>> ${store.state.topBar.title}`) */
  },
  methods: {
    isLoggedOut() {
      localStorage.clear();
      location.reload()
      },
    goto(to) {
      const { id } = this.$route.params
    
      if (to === 'experimental') {
        this.$router.push({ path: `/projects/${id}/experimental` })
        store.commit('activeSec', 'experimental')
      } else if (to === 'processing') {
        this.$router.push({ path: `/projects/${id}/processing` })
        store.commit('activeSec', 'processing')
      } else if (to === 'downstream') {
        this.$router.push({ path: `/projects/${id}/downstream` })
        store.commit('activeSec', 'downstream')
      } else if (to === 'viewers') {
        this.$router.push({ path: `/projects/${id}/viewers` })
        store.commit('activeSec', 'viewers')
      }
    },
  },
}
</script>
<style>
.navbar-container {
  height: 60px;
}
#topBar{
    height: 60px;
    width: 100%;
    position:relative;
}
#topBar .content{
    border-right: 1px #22292f20 solid;
    text-transform: uppercase;
}
#topBar .content.navbar-button{
  font-weight: 400;
  font-size: 75%;
  cursor: pointer
}
#topBar .content.navbar-button:hover, #topBar .content.navbar-button.active {
  color: #ffffff;
  background-color: #028380;

}
#topLogout{
  position:absolute;
  right:0;
  border-left: 1px #22292f20 solid;
  font-size: 10px;

}
</style>
